module.exports = __webpack_public_path__ + "img/JIM-logo.04a93160.svg";